<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">    
      <input type="file" id="coverthumb" @change="uploadfiles($event)" style="display:none"/>
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
          	  <el-select v-model="query.groupid" placeholder="请选择用户分类">
          	      <el-option label="不选择分类" value="0"></el-option>
                  <el-option v-for="(item,index) in classlists" :label="item.groupname" :value="item.id" :key="index" v-if="item.isroll=='是'"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item ref="query" :model="query">
              <el-input placeholder="用户姓名 / 登录手机号码" v-model="query.key" ></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="addDialog" v-if="actionauth.config_manager_add=='true'">新增用户</el-button>
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="showClassDialog">用户分类管理</el-button>
          </el-form-item>
      </el-form>
      <!------------------------search end---------------------->
      
      <el-tag type="danger" closable  @close="closetag" v-if="tagshow=='true'" style="margin-top:10px">温馨提示：创始人用户信息不能删除，且其手机号码、用户分类不能编辑</el-tag>

      <!------------------------class list---------------------->
      <el-dialog title="用户分类管理" :visible.sync="classDialog" top="5vh">
        <el-tag type="danger">温馨提示：用户只能选择已经分配权限的分类，建议添加组别后立即设置分配权限</el-tag>
        <el-form :inline="true" class="demo-form-inline" style="margin-top:15px" size="medium">
          <el-form-item v-if="actionauth.config_manager_cate_add=='true'">
            <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="createClassDialog = true">新增用户分类</el-button>
          </el-form-item>
        </el-form>
          <el-table :data="classlists" style="width: 100%">
              <el-table-column label="用户分类名称">
              	  <template slot-scope="scope">
              	  	  <span v-if="scope.row.id==1" style="color:green">{{scope.row.groupname}}</span>
              	  	  <span v-if="scope.row.id!=1">{{scope.row.groupname}}</span>
	              </template>
              </el-table-column>
              <el-table-column label="是否设置权限" prop="isroll" align="center">
              	  <template slot-scope="scope">
              	  	  <el-tag v-if="scope.row.isroll=='是'" type="success">{{scope.row.isroll}}</el-tag>
              	  	  <el-tag v-if="scope.row.isroll=='否'" type="danger">{{scope.row.isroll}}</el-tag>
	              </template>
              </el-table-column>
              <el-table-column
	              label="操作"
	              width="200" align="center" 
                v-if="actionauth.config_manager_cate_edit=='true' || actionauth.config_manager_cate_del=='true' || actionauth.config_manager_authority=='true'"
              >
	            <template slot-scope="scope">
	              	<el-button type="primary" size="small" circle icon="el-icon-setting"  @click="editauthority(scope.row)" v-if="scope.row.id!=1 && actionauth.config_manager_authority=='true'"></el-button>
	                <el-button type="primary" size="small" circle icon="el-icon-edit"  @click="editClassDialog(scope.row)" v-if="scope.row.id!=1 && actionauth.config_manager_cate_edit=='true'"></el-button>
	                <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delClass(scope.row)" v-if="scope.row.id!=1 && actionauth.config_manager_cate_del=='true'"></el-button>
	            </template>
              </el-table-column>
          </el-table>
      </el-dialog>
      <!------------------------class list end---------------------->

      <!------------------------add class---------------------->
        <el-dialog title="新增用户分类" :visible.sync="createClassDialog" width="30%">
          <el-form ref="createclass" :model="createclass" :rules="classrules" label-width="100px" size="medium">
            <el-col :span="22">
              <el-form-item label="分类名称" prop="groupname">
                <el-input v-model="createclass.groupname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="createClassDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="createClassLoading" @click="createClassSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------add class end---------------------->

      <!------------------------edit class---------------------->
        <el-dialog title="编辑分类" :visible.sync="updateClassDialog" width="30%">
          <el-form ref="updateclass" :model="updateclass" :rules="classrules" label-width="100px" size="medium">
            <el-col :span="22">
              <el-form-item label="分类名称" prop="groupname">
                <el-input v-model="updateclass.groupname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateClassDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateClassLoading" @click="updateClassSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------edit class end---------------------->

      <!------------------------add---------------------->
        <el-dialog title="新增用户" :visible.sync="createDialog" width="40%">
          <el-tag type="danger">温馨提示：如没有找到用户分类信息请前往用户分类管理查询该分类是否设置权限</el-tag>
          <el-form ref="create" :model="create" :rules="rules" label-width="100px" style="margin-top:15px" size="medium">
            <el-col :span="22">
                <el-form-item label="用户头像">
                    <div class="managelogo">
                       <a href="javascript:;" @click="getmanagethumb('add')">
                          <img src="../../assets/manager-logo.png" v-if="create.showthumb==''" />
                          <img :src="create.showthumb"  v-if="create.showthumb!=''"/>
                       </a>
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="22">
                <el-form-item label="用户姓名" prop="truename">
                  <el-input v-model="create.truename"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="22">
                <el-form-item label="登录手机" prop="phone">
                  <el-input v-model="create.phone"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="用户分类">
                <el-select v-model="create.groupid" placeholder="请选择用户分类">
                  <el-option v-for="(item,index) in classlists" :label="item.groupname" :value="item.id" :key="index" v-if="item.isroll=='是'"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="默认发货仓库">
                <el-select v-model="create.warehouse" placeholder="请选择默认发货仓库">
                  <el-option label="不选仓库" value=""></el-option>
                  <el-option v-for="(item,index) in warelists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="默认开单职员" label-width="180">
                <el-tooltip class="item" effect="dark" content="新增销售订单时默认选中销售员为该人员" placement="top">
                <el-select v-model="create.default_seller_id" clearable filterable placeholder="请选择开单默认业务员">
                  <el-option v-for="(item,index) in sellerLists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
             <el-col :span="22">
              <el-form-item label="默认采购职员" label-width="180">
                <el-tooltip class="item" effect="dark" content="新增采购订单时默认选中采购员为该人员" placement="top">
                <el-select v-model="create.default_purchase_id" clearable filterable placeholder="请选择采购默认业务员">
                  <el-option v-for="(item,index) in sellerLists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="22">
                <el-form-item label="密码">
                  <el-input v-model="create.password" type="password"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="22">
                <el-form-item label="确认密码">
                  <el-input v-model="create.password2" type="password"></el-input>
                </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="createDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------add end---------------------->
      <div class="backborder2" :style="csstop">
        <el-table :data="lists" v-loading="listLoading">
          <el-table-column prop="id" label="编号" width="80"></el-table-column>
          <el-table-column label="用户头像" width="120">
              <template slot-scope="scope">
                  <div class="managelogo">
                      <img src="../../assets/manager-logo.png" v-if="scope.row.showthumb==''" />
                      <img :src="scope.row.showthumb"  v-if="scope.row.showthumb!=''"/>
                  </div>
              </template>
          </el-table-column>
          <el-table-column prop="truename" label="用户姓名"></el-table-column>
          <el-table-column prop="groupname" label="所属分类"></el-table-column>
          <el-table-column prop="phone" label="登录手机"></el-table-column>
          <el-table-column label="操作" width="300" align="center" v-if="actionauth.config_manager_edit=='true' || actionauth.config_manager_del=='true'">
	          <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="设置管理员对销售订单、销售单的查看权限" placement="top-start">
                <el-button type="warning" size="small" round @click="editsellauth(scope.row)" v-if="scope.row.isadmin!=1 && actionauth.config_manager_edit=='true'">销售单权限设置</el-button>
	              </el-tooltip>
                <el-button type="warning" size="small" round @click="editCurrent(scope.row)" v-if="actionauth.config_manager_edit=='true'">编辑</el-button>
	              <el-button type="danger" size="small" round @click="delCurrent(scope.row)" v-if="scope.row.isadmin!=1 && actionauth.config_manager_del=='true'">删除</el-button>
	          </template>
          </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="pageCurrentChange"
            :current-page="query.p"
            :page-sizes="[10, 20, 50]"
            :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
	  </div>
      <!------------------------edit---------------------->
        <el-dialog title="编辑用户信息" :visible.sync="updateDialog" width="40%">
          <el-tag type="danger">温馨提示：如没有找到用户分类信息请前往用户分类管理查询该分类是否设置权限</el-tag>
          <el-form ref="update" :model="update" :rules="rules" label-width="100px" style="margin-top:15px" size="medium">
            <el-col :span="22">
                <el-form-item label="用户头像">
                    <div class="managelogo">
                       <a href="javascript:;" @click="getmanagethumb('update')">
                          <img src="../../assets/manager-logo.png" v-if="update.showthumb==''" />
                          <img :src="update.showthumb"  v-if="update.showthumb!=''"/>
                       </a>
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="22">
                <el-form-item label="用户姓名" prop="truename">
                  <el-input v-model="update.truename"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="22">
                <el-form-item label="登录手机" prop="phone">
                  <el-input v-model="update.phone" :disabled="true" v-if="update.isadmin==1"></el-input>
                  <el-input v-model="update.phone" v-if="update.isadmin==2"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="用户分类">
                <el-select v-model="update.groupid" placeholder="请选择用户分类" v-if="update.isadmin==1" disabled>
                  <el-option v-for="(item,index) in classlists" :label="item.groupname" :value="item.id" :key="index" v-if="item.isroll=='是'"></el-option>
                </el-select>
                <el-select v-model="update.groupid" placeholder="请选择用户分类" v-if="update.isadmin==2">
                  <el-option v-for="(item,index) in classlists" :label="item.groupname" :value="item.id" :key="index" v-if="item.isroll=='是'"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="默认发货仓库">
                <el-select v-model="update.warehouse" placeholder="请选择所属仓库">
                  <el-option label="不选仓库" value=""></el-option>
                  <el-option v-for="(item,index) in warelists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="默认开单职员" label-width="180">
                <el-tooltip class="item" effect="dark" content="新增销售订单时默认选中销售员为该人员" placement="top">
                <el-select v-model="update.default_seller_id" clearable filterable placeholder="请选择开单默认业务员">
                  <el-option v-for="(item,index) in sellerLists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
             <el-col :span="22">
              <el-form-item label="默认采购职员" label-width="180">
                <el-tooltip class="item" effect="dark" content="新增采购订单时默认选中采购员为该人员" placement="top">
                <el-select v-model="update.default_purchase_id" clearable filterable placeholder="请选择采购默认业务员">
                  <el-option v-for="(item,index) in sellerLists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="22">
                <el-form-item label="密码">
                  <el-input v-model="update.password" type="password"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="22">
                <el-form-item label="确认密码">
                  <el-input v-model="update.password2" type="password"></el-input>
                </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------edit end---------------------->
      
      <!------------------------权限修改开始---------------------->
      <el-dialog title="修改分类权限" :visible.sync="updateauthorityDialog" width="60%" top="5vh">
	      <el-tree ref="tree" v-loading="treeLoading" :data="authority" highlight-current show-checkbox node-key="id" :default-checked-keys="myauthority"></el-tree>
      	  <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateauthorityDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateauthorityLoading" @click="updateauthoritySave">保 存</el-button>
          </div>
      </el-dialog>
      <!------------------------权限修改结束---------------------->

      <!-- 修改销售订单的查看权限 -->
      <el-dialog title="销售单查看权限" :visible.sync="sellauth.dialog" width="50%" top="10vh">
          <div v-loading="sellauth.loading">

            <div style="display:inline-block;width:90%;padding:5px 5%;background:#dddddd;border-radius:6px;margin-bottom:20px;">
                <span style="font-size:13px;line-height:15px;color:#f78989;display:inline-block;width:100%">1、该功能为限制管理员对销售订单的查看范围（销售员级）；</span>
                <span style="font-size:13px;line-height:15px;color:#f78989;display:inline-block;width:100%">2、全不选/全选时有查看所有销售员订单的权限。</span>
            </div>

            <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <div v-for="(item,index) in managerlists" :key="index" style="display:inline-block;width:25%;padding:5px 0">
            <el-checkbox v-model="item.istrue" @change="changesell">{{item.name}}</el-checkbox>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="sellauth.dialog = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="savesellauth">保 存</el-button>
          </div>
      </el-dialog>
      <!-- 修改销售订单的查看权限 -->

      <!---------------  打开编辑管理员头像 ----------->
      <div>
          <my-upload field="img"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="changethumbDialog"
              :width="100"
              :height="100"
              :url="this.GLOBAL.uploadavarge"
              :params="params"
              :headers="headers"
              noSquare="false"
              img-format="png">
          </my-upload>
      </div>
      
  </div>
  </transition> 
</template>

<script>
import myUpload from 'vue-image-crop-upload';
export default {
  data () {
    return {
      actionauth:'', //功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Manager/index",
      lists:[],
      listLoading:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        groupid:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows: 0,
      createDialog: false,
      createLoading: false,
      treeLoading: false,
      updateauthorityLoading: false,
      create: {
        act:'add',
        token:this.$cookies.get('token'),
        truename:'',
        phone:'',
        groupid:'',
        warehouse:'',
        password:'',
        password2:'',
        thumb:'',
        showthumb:'',
        default_seller_id:'',
        default_purchase_id:'',
      },
      updateDialog:false,
      updateauthorityDialog:false,
      updateLoading:false,
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        id:'',
        isadmin:'',
        truename:'',
        phone:'',
        groupid:'',
        warehouse:'',
        password:'',
        password2:'',
        thumb:'',
        showthumb:'',
        default_seller_id:'',
        default_purchase_id:'',
      },
      rules: {
        truename: [
            { required: true, message: '请输入用户姓名', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符'}
        ],
        phone: [
            { required: true, message: '请输入登录手机', trigger: 'blur' },
            { pattern:/^[0-9]+$/, message: '请输入正确的手机号码'}
        ]
      },
      classDialog:false,
      createClassDialog:false,
      createClassLoading:false,
      createclass: {
        act:'addclass',
        token:this.$cookies.get('token'),
        groupname:'',
      },
      classrules: {
        groupname: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字符'}
        ]
      },
      classlists:[],
      warelists:[],
      authority:[],
      classListLoading:false,
      wareListLoading:false,
      updateClassDialog:false,
      updateClassLoading:false,
      updateclass: {
        act:'editclass',
        token:this.$cookies.get('token'),
        id:'',
        groupname:'',
      },
      authority:[],
      myauthority:[],
      authoritygroupid:[], 
      authoritygroupname:[], 
      tagshow:'true',
      csstop:{'margin-top':'10px'},
      changethumbtype:'',
      changethumbDialog:false,

			params: {
				token: '123456798',
				name: 'avatar'
			},
			headers: {
				smail: '*_~'
			},

      avatartype:'',

      checkAll:false,
      isIndeterminate:false,
      sellauth: {
          act:'getsellauth',
          token:this.$cookies.get('token'),
          dialog:false,
          loading:false,
          id:'',
      },
      managerlists:[],
      sellerLists:[],

    }
  },
  mounted(){
    this.getactionauth();
    this.getList();
    this.getClassList();
    this.getseller(); //获取所有销售员信息
  },
  components: {
      myUpload,
  },
  methods:{


    /** 获取销售员 **/
    getseller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));                     
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },


    /** 设置销售单查看权限 **/
    editsellauth(item) {
        this.sellauth.dialog=true;
        this.sellauth.loading=true;
        this.sellauth.id=item.id;

        var resource = this.$resource(this.url);
        resource.save(this.sellauth).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.sellauth.loading=false;
            }else{
                this.managerlists = JSON.parse(Base64.decode(res.data.Data));
                let nums=0;
                this.checkAll=false;
                let _this=this;
                this.managerlists.forEach(function(item,index) {
                    item.istrue==1 ? nums++ : '';
                    item.istrue==1 ? item.istrue=true : item.istrue=false;
                });
                if(nums > 0) this.checkAll=true;
                this.sellauth.loading=false;
            }
        }).catch((res) => {
            this.sellauth.loading=false;
        });
    },

    /** 全选/全不选的销售员 **/
    handleCheckAllChange() {
        let _this=this;
        this.managerlists.forEach(function(item,index) {
             item.istrue=_this.checkAll;
        });
    },

    changesell() {
        let _this=this;
        let nums=0;
        this.managerlists.forEach(function(item,index) {
             item.istrue ? nums++ : '';
        });
        nums > 0 ? this.checkAll=true : this.checkAll=false;
    },


    /** 保存选中的查看销售员信息 **/
    savesellauth() {
        let ids=[];
        this.managerlists.forEach(function(item,index) {
             item.istrue ? ids.push(item.id) : '';
        });

        this.sellauth.loading=true;
        var resource = this.$resource(this.url);
        resource.save({act:'savesellclerkids',token:this.$cookies.get('token'),id:this.sellauth.id,ids:ids.join(",")}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.sellauth.loading=false;
            }else{
                this.sellauth.loading=false;
                this.sellauth.dialog=false;
                this.getList();
            }
        }).catch((res) => {
            this.sellauth.loading=false;
        });

    },

  
    closetag() {
        this.tagshow='false';
    },
   
    /** 获取操作权限 **/
	  getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  	
    //重置表单
    reset() {
        this.$refs.create.resetFields();
        this.create.password='';
        this.create.password2='';
        this.create.thumb='';
        this.create.showthumb='';
        this.create.default_seller_id='';
        this.create.default_purchase_id='';
    },
    //显示新增对话框
    addDialog(){
      this.createDialog=true;
      this.getWareList();
      this.getClassList();
    },
    //新增
    createSave(){
      // 主动校验
      this.$refs.create.validate((valid) => {
          if (valid) {
              this.createLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.create).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.createLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.createDialog=false;
                    this.createLoading=false;
                    this.reset();
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createDialog=false;
                  this.createLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //信息列表
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          var _this=this;
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.lists.forEach(function(item,i) {
              item.thumb!='' && item.thumb!=null ? _this.lists[i].thumb=item.thumb : _this.lists[i].thumb='';
              item.thumb!='' && item.thumb!=null ? _this.lists[i].showthumb=_this.GLOBAL.staticUrl+item.thumb : _this.lists[i].showthumb='';
          });
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    //编辑
    editCurrent(item){
        this.getWareList();
        this.getClassList();
        this.update.id=item.id;
        this.update.truename=item.truename;
        this.update.phone=item.phone;
        this.update.groupid=item.groupid;
        this.update.warehouse=item.warehouse;
        this.update.isadmin=item.isadmin;
        this.update.thumb=item.thumb=='' ? '' : item.thumb;
        this.update.showthumb=item.thumb=='' ? '' : this.GLOBAL.staticUrl+item.thumb;
        this.update.default_seller_id=item.default_seller_id > 0 ? item.default_seller_id : '';
        this.update.default_purchase_id=item.default_purchase_id > 0 ? item.default_purchase_id : '';
        this.updateDialog=true;
    },
    //更新
    updateSave(){
      // 主动校验
      this.$refs.update.validate((valid) => {
          if (valid) {
              this.updateLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateDialog=false;
                    this.updateLoading=false;
                    
                    var result = JSON.parse(Base64.decode(res.data.Data));
                    if(result.id > 0) {
                        this.$cookies.set('thumb',this.GLOBAL.staticUrl+result.thumb,604800);
                        this.$cookies.set('truename',result.truename,604800);
                    }

                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.updateDialog=false;
                  this.updateLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //删除
    delCurrent(item){
      this.$confirm('此操作将永久删除 ' + item.truename + ', 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.truename + '!');
                    this.getList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    //重置分类表单
    resetClass() {
        this.$refs.createclass.resetFields();
    },
    //分类列表
    showClassDialog(){
    	this.$emit('listenchild',{name:'用户分类管理',url:'Managercate'});
        //this.classDialog=true;
        //this.getClassList();
    },
    //新增分类
    createClassSave(){
      // 主动校验
      this.$refs.createclass.validate((valid) => {
          if (valid) {
              this.createClassLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.createclass).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.createClassLoading=false;
                  }else{
                    this.$message.success('新增分类：'+this.createclass.groupname+'成功，请立刻给该分类分配权限');
                    this.createClassDialog=false;
                    this.createClassLoading=false;
                    this.resetClass();
                    this.getClassList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createClassDialog=false;
                  this.createClassLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    
    //分类列表
    getClassList(){
      this.classListLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act:'getClass',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.classListLoading = false;
        }else{
          this.classlists = JSON.parse(Base64.decode(res.data.Data));
          this.classListLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.classListLoading=false;
      });
    },
    //仓库列表
    getWareList(){
      this.wareListLoading = true;
      var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
      resource.query({act:'lists',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.wareListLoading = false;
        }else{
          this.warelists = JSON.parse(Base64.decode(res.data.Data));
          this.wareListLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.wareListLoading=false;
      });
    },
    //显示编辑分类框
    editClassDialog(item){
      this.updateClassDialog=true;
      this.updateclass.id=item.id;
      this.updateclass.groupname=item.groupname;
    },
    //编辑分类的保存
    updateClassSave(){
      // 主动校验
      this.$refs.updateclass.validate((valid) => {
          if (valid) {
              this.updateClassLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.updateclass).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.updateClassLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateClassDialog=false;
                    this.updateClassLoading=false;
                    this.getClassList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createClassDialog=false;
                  this.createClassLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    
    //删除
    delClass(item){
      this.$confirm('此操作将永久删除 ' + item.groupname + ', 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'delclass',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.groupname + '!');
                    this.getClassList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    
    
    //获取用户权限
    editauthority(obj) {
    	this.updateauthorityDialog=true;
    	this.treeLoading=true;
    	this.authoritygroupid=obj.id;
    	this.authoritygroupname=obj.groupname;
    	var resource = this.$resource(this.GLOBAL.domain+"Authority/index");
    	resource.query({ act:'myauthority',groupid:obj.id,type:'change',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.treeLoading=false;
	        }else{
	            var mymenu = JSON.parse(Base64.decode(res.data.Data));
	            this.authority=mymenu.menus;
			    //勾选当前用户具有的权限
			    if(mymenu.ids!='') {
			  	    this.$refs.tree.setCheckedKeys(mymenu.ids);
			    }else {
			  	    this.$refs.tree.setCheckedKeys([]);
			    }
			    this.treeLoading=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.treeLoading=false;
        });
    },
    
    
    //保存修改后的权限
    updateauthoritySave() {
    	this.updateauthorityLoading=true;
    	var ids=this.$refs.tree.getCheckedKeys();
    	if(ids=='') {
    	    this.$message.error('请选择相关权限');
    	    this.updateauthorityLoading=false;
    	    return false;
    	}
    	
    	var resource = this.$resource(this.GLOBAL.domain+"Authority/index");
    	resource.query({ act:'savemyauthority',groupid:this.authoritygroupid,ids:ids,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.updateauthorityLoading=false;
	            this.updateauthorityDialog=false;
	        }else{
	            this.$message.success('设置分类：'+this.authoritygroupname+'权限成功');
			    this.updateauthorityLoading=false;
			    this.updateauthorityDialog=false;
			    this.getClassList();
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.updateauthorityLoading=false;
            this.updateauthorityDialog=false;
        });
    },

    //开启切换头像开关
    getmanagethumb(type) {
        this.avatartype=type;
        document.getElementById('coverthumb').click();

        //this.changethumbtype=type;
        //this.changethumbDialog=true;
    },


    /** 获取图片信息回传 **/
		uploadfiles(el) {
			  var images=el.target.files;
			  var resource = this.$resource(this.GLOBAL.uploadUrl);
	    	for (let i = 0; i < el.target.files.length; i++) {
	    		  var formData = new FormData();
	    		  formData.append('file', el.target.files[i]);
            formData.append('sys_type', 'cz');
            formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    		  resource.save(formData).then((res) => {
		            var data=JSON.parse(Base64.decode(res.body.Data));
		            if(data.Result > 0) {
		            	  this.$message.error(data.msg);
		            }else {
                    this.avatartype=='add' ? 
                    this.create.thumb=data.imgsrc : 
                    this.update.thumb=data.imgsrc;

                    this.avatartype=='add' ? 
                    this.create.showthumb=this.GLOBAL.staticUrl+data.imgsrc : 
                    this.update.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
						
		            }
		        }).catch((res) => {
		        	
		        });
	    	}
			  el.target.value = '';  
		},







    //头像上传成功
    cropUploadSuccess(res) {
        var data = JSON.parse(Base64.decode(res.Data));
        if(this.changethumbtype=='add') {
            this.create.thumb=data.imgsrc;
            this.create.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
        }else {
            this.update.thumb=data.imgsrc;
            this.update.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
        }
    },

    cropUploadFail(res) {
        //alert(res);
    },
    
    cropSuccess(res) {
        //alert(res);
    },
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.managelogo {float:left;width:50px;height:50px;border-radius:50%;overflow:hidden;background:#fff;border:1px solid #dcdfe6;padding:.2rem;display:flex;justify-content:center;align-items:center;}
.managelogo img {float:left;width:45px;height:45px;background:#ddd;border-radius:50%}
.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right {float:left;margin-left:30px}
</style>


// WEBPACK FOOTER //
// src/components/config/Manager.vue